import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { rankingPDFUrl, scorePDFUrl } from '../../../../configs/ContactConfig';

const mapStateToProps = state => ({
  i18n: state.i18n,
});

export default connect(mapStateToProps)(Footer);

function Footer(props) {
  const currentTab = props.currentTab;

  const SETTING_RANKING = {
    text: 'stRanking.footerTextRanking',
    link: rankingPDFUrl,
  };

  const SETTING_SCORE = {
    text: 'stRanking.footerTextScore',
    link: scorePDFUrl,
  };

  const SETTING = currentTab === 1 ? SETTING_RANKING : SETTING_SCORE;

  return (
    <div
      className="unit-title-note"
      style={{ marginTop: 10, marginBottom: 10 }}
    >
      <span>{I18n.t(SETTING.text)}</span>
      <a href={SETTING.link} target="_blank" rel="noopener noreferrer">
        <span>{I18n.t('stRanking.footerClickHere')}</span>
      </a>
    </div>
  );
}
